import exoFrame from '@/common/exoFrame/exoFrame'
export default exoFrame